var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 135 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #fff;\n        stroke-miterlimit: 1;\n        stroke-width: .2px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #100f0d;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #f6b60b;\n      }\n\n      .cls-6 {\n        fill: #a2a2a1;\n      }\n\n      .cls-7 {\n        fill: #3bad49;\n      }\n\n      .cls-8 {\n        fill: #5778c5;\n      }\n\n      .cls-9 {\n        fill: #eb3131;\n      }\n    "), /*#__PURE__*/React.createElement("symbol", {
    id: "glyph0-1",
    viewBox: "0 0 6.1 6.3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6,3.3h-2.9v-.7h2.2c0-.6-.3-1-.7-1.4-.4-.3-.9-.5-1.5-.5s-1.2.2-1.7.7c-.4.5-.7,1-.7,1.7s.2,1.2.7,1.7c.5.5,1,.7,1.7.7s.7,0,1-.2.5-.3.7-.5l.6.5c-.2.3-.6.5-1,.7-.4.2-.8.2-1.2.2-.9,0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2S.3,1.5.9.9s1.3-.9,2.2-.9,1.6.3,2.2.9c.5.5.8,1.2.8,2s0,.3,0,.5Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "glyph0-2",
    viewBox: "0 0 3.5 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,6V0h3.5v.7H.8v1.9h2.5v.7H.8v1.9h2.7v.7H0Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "glyph0-3",
    viewBox: "0 0 4.1 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.1,5.3v.7H0v-.7h1.7V0h.8v5.3h1.7Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "glyph0-4",
    viewBox: "0 0 .8 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.8,6h-.8V0h.8v6Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "glyph0-5",
    viewBox: "0 0 6.2 6.3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.3,5.4c-.6.6-1.3.9-2.2.9s-1.6-.3-2.2-.9c-.6-.6-.9-1.3-.9-2.2S.3,1.5.9.9s1.3-.9,2.2-.9,1.6.3,2.2.9c.6.6.9,1.3.9,2.2s-.3,1.6-.9,2.2ZM1.4,4.9c.4.5,1,.7,1.6.7s1.2-.2,1.6-.7.7-1,.7-1.7-.2-1.3-.7-1.7c-.4-.5-1-.7-1.6-.7s-1.2.2-1.6.7-.7,1-.7,1.7.2,1.3.7,1.7Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "glyph0-6",
    viewBox: "0 0 4.6 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.8,3.7v1.2s0,0,0,0L3.8,0h.8v6h-.8V1.3s0,0,0,0L.9,6h-.9V0h.8v3.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 61.5,
    y: 14,
    width: 135,
    height: 41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130,41H5c-2.8,0-5-2.2-5-5V6C0,3.2,2.2,1,5,1h125c2.8,0,5,2.2,5,5v30c0,2.8-2.2,5-5,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130,1H5C2.2,1,0,3.2,0,6v30c0,2.8,2.2,5,5,5h125c2.8,0,5-2.2,5-5V6c0-2.8-2.2-5-5-5ZM130,1.8c2.3,0,4.2,1.9,4.2,4.2v30c0,2.3-1.9,4.2-4.2,4.2H5c-2.3,0-4.2-1.9-4.2-4.2V6C.8,3.7,2.7,1.8,5,1.8h125"
  }), /*#__PURE__*/React.createElement("use", {
    width: 6.1,
    height: 6.3,
    transform: "translate(41.4 14.1) scale(1 -1)",
    xlinkHref: "#glyph0-1"
  }), /*#__PURE__*/React.createElement("use", {
    width: 3.5,
    height: 6,
    transform: "translate(48.5 14) scale(1 -1)",
    xlinkHref: "#glyph0-2"
  }), /*#__PURE__*/React.createElement("use", {
    width: 4.1,
    height: 6,
    transform: "translate(52.8 14) scale(1 -1)",
    xlinkHref: "#glyph0-3"
  }), /*#__PURE__*/React.createElement("use", {
    width: 0.8,
    height: 6,
    transform: "translate(59.9 14) scale(1 -1)",
    xlinkHref: "#glyph0-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("use", {
    width: 4.1,
    height: 6,
    transform: "translate(61.7 14) scale(1 -1)",
    xlinkHref: "#glyph0-3"
  })), /*#__PURE__*/React.createElement("use", {
    width: 6.2,
    height: 6.3,
    transform: "translate(68.3 14.1) scale(1 -1)",
    xlinkHref: "#glyph0-5"
  }), /*#__PURE__*/React.createElement("use", {
    width: 4.6,
    height: 6,
    transform: "translate(75.6 14) scale(1 -1)",
    xlinkHref: "#glyph0-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.4,10.8h-2.9v.7h2.2c0,.6-.3,1.1-.7,1.4s-.9.5-1.5.5-1.2-.2-1.7-.7c-.4-.5-.7-1-.7-1.7s.2-1.3.7-1.7c.5-.5,1-.7,1.7-.7s.7,0,1,.2c.3.1.5.3.7.5l.6-.6c-.3-.3-.6-.5-1-.7-.4-.2-.8-.2-1.3-.2-.9,0-1.6.3-2.2.9-.6.6-.9,1.4-.9,2.2s.3,1.6.9,2.2c.6.6,1.3.9,2.2.9s1.7-.3,2.2-.9c.5-.5.7-1.2.7-2s0-.3,0-.5ZM48.5,8v6h3.5v-.7h-2.7v-1.9h2.5v-.7h-2.5v-1.9h2.7v-.7h-3.5ZM57,8.7v-.7h-4.1v.7h1.7v5.3h.8v-5.3h1.7ZM60.7,8h-.8v6h.8v-6ZM65.8,8.7v-.7h-4.1v.7h1.7v5.3h.8v-5.3h1.7ZM73.6,8.8c-.6-.6-1.3-.9-2.2-.9s-1.6.3-2.2.9c-.6.6-.9,1.3-.9,2.2s.3,1.6.9,2.2c.6.6,1.3.9,2.2.9s1.6-.3,2.2-.9c.6-.6.9-1.3.9-2.2s-.3-1.6-.9-2.2ZM69.8,9.3c.4-.5,1-.7,1.6-.7s1.2.2,1.6.7c.4.4.7,1,.7,1.7s-.2,1.3-.7,1.7c-.4.5-1,.7-1.6.7s-1.2-.2-1.6-.7c-.4-.5-.7-1-.7-1.7s.2-1.3.7-1.7ZM76.4,10.2v-1.2s0,0,0,0l3.1,4.9h.8v-6h-.8v4.7s0,0,0,0l-2.9-4.7h-.9v6h.8v-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.9,31h1.9v-12.5h-1.9v12.5ZM123.7,23l-2.1,5.4h0l-2.2-5.4h-2l3.3,7.6-1.9,4.2h1.9l5.1-11.8h-2.1ZM113.2,29.6c-.6,0-1.5-.3-1.5-1.1s1.1-1.3,2-1.3,1.2.2,1.7.4c-.1,1.2-1.1,2-2.2,2ZM113.4,22.7c-1.4,0-2.8.6-3.3,1.9l1.7.7c.4-.7,1-.9,1.7-.9s1.9.6,2,1.6h0c-.3,0-1.1-.4-1.9-.4-1.8,0-3.6,1-3.6,2.8s1.5,2.8,3.1,2.8,1.9-.6,2.4-1.2h0v1h1.8v-4.8c0-2.2-1.7-3.5-3.8-3.5ZM101.9,24.5h-2.7v-4.3h2.7c1.4,0,2.2,1.2,2.2,2.1s-.8,2.1-2.2,2.1ZM101.8,18.5h-4.5v12.5h1.9v-4.7h2.6c2.1,0,4.1-1.5,4.1-3.9s-2-3.9-4.1-3.9ZM77.4,29.6c-1.3,0-2.4-1.1-2.4-2.6s1.1-2.6,2.4-2.6,2.3,1.1,2.3,2.6-1,2.6-2.3,2.6ZM79.6,23.7h0c-.4-.5-1.2-1-2.2-1-2.1,0-4.1,1.9-4.1,4.3s1.9,4.2,4.1,4.2,1.8-.5,2.2-1h0v.6c0,1.6-.9,2.5-2.3,2.5s-1.9-.8-2.1-1.5l-1.6.7c.5,1.1,1.7,2.5,3.8,2.5s4-1.3,4-4.4v-7.6h-1.8v.7ZM82.6,31h1.9v-12.5h-1.9v12.5ZM87.3,26.9c0-1.6,1.3-2.5,2.2-2.5s1.4.4,1.6.9l-3.8,1.6ZM93.1,25.5c-.4-.9-1.4-2.7-3.6-2.7s-4,1.7-4,4.3,1.8,4.3,4.2,4.3,3.1-1.2,3.5-1.9l-1.4-1c-.5.7-1.1,1.2-2.1,1.2s-1.6-.4-2.1-1.3l5.7-2.4-.2-.5ZM47.7,24.1v1.8h4.3c-.1,1-.5,1.8-1,2.3s-1.6,1.3-3.3,1.3c-2.7,0-4.7-2.1-4.7-4.8s2.1-4.8,4.7-4.8,2.5.6,3.3,1.3l1.3-1.3c-1.1-1-2.5-1.8-4.5-1.8-3.6,0-6.7,3-6.7,6.6s3.1,6.6,6.7,6.6,3.4-.6,4.6-1.9c1.2-1.2,1.6-2.9,1.6-4.2s0-.8,0-1.1h-6.1ZM58.8,29.6c-1.3,0-2.4-1.1-2.4-2.6s1.1-2.6,2.4-2.6,2.4,1,2.4,2.6-1.1,2.6-2.4,2.6ZM58.8,22.8c-2.4,0-4.3,1.8-4.3,4.3s1.9,4.3,4.3,4.3,4.3-1.8,4.3-4.3-1.9-4.3-4.3-4.3ZM68.1,29.6c-1.3,0-2.4-1.1-2.4-2.6s1.1-2.6,2.4-2.6,2.4,1,2.4,2.6-1.1,2.6-2.4,2.6ZM68.1,22.8c-2.4,0-4.3,1.8-4.3,4.3s1.9,4.3,4.3,4.3,4.3-1.8,4.3-4.3-1.9-4.3-4.3-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.7,20.4l-10.6,11.3s0,0,0,0c.3,1.2,1.4,2.1,2.8,2.1s1-.1,1.5-.4h0s12-6.9,12-6.9l-5.6-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.5,18.5h0s-5.2-3-5.2-3l-5.8,5.2,5.8,5.8,5.1-3c.9-.5,1.5-1.4,1.5-2.5s-.6-2-1.5-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M10.1,10.3c0,.2,0,.5,0,.7v20c0,.3,0,.5,0,.7l11-11-11-10.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M20.8,21l5.5-5.5-12-6.9c-.4-.3-.9-.4-1.5-.4-1.3,0-2.4.9-2.8,2.1h0s10.7,10.7,10.7,10.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.09eb81531af89bb581083cfe9709aa50.svg";
export { ForwardRef as ReactComponent };